export default "__VITE_ASSET__CCh7PF16__"